import { FilterSection } from "@flights/search-ui";
import React from "react";
import { useStopsFilterController } from "./useStopsFilter.controller";
import { Stack } from "@bookingcom/bui-react";
import { StopsFilterItem } from "./StopsFilterItem";
import flights_web_budget_layover_airports_filters from "../../../../../utils/experiments/funnel/flights_web_budget_layover_airports_filters";

export const StopsFilterMobile = () => {
  const { title, showReset, resetLabel, onClickReset, options, value, onChange, isFilterAvailable } =
    useStopsFilterController();

  if (!isFilterAvailable) {
    return null;
  }

  const addNewFilters = !!flights_web_budget_layover_airports_filters.trackWithDefaultStage();

  return (
    <FilterSection
      attributes={{ "data-testid": "stops_filter" }}
      title={{
        text: title,
        tagName: "h3",
        attributes: { id: "stops_filter" },
        variant: addNewFilters ? "strong_2" : "emphasized_1"
      }}
      reset={
        showReset && !addNewFilters
          ? { text: resetLabel, onClick: onClickReset, attributes: { "data-testid": "search_filter_stops_reset" } }
          : undefined
      }
    >
      <Stack gap={4}>
        {options.map((option, i) => (
          <StopsFilterItem
            key={`${option.label}-${i}-${option.count}`}
            label={option.label}
            priceLabel={option.priceLabel}
            count={option.count}
            value={option.value}
            checked={value === option.value}
            onChange={onChange}
          />
        ))}
      </Stack>
    </FilterSection>
  );
};
